import { render, staticRenderFns } from "./YearlyReport.vue?vue&type=template&id=4bd54e9b&scoped=true&"
import script from "./YearlyReport.vue?vue&type=script&lang=js&"
export * from "./YearlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd54e9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd54e9b')) {
      api.createRecord('4bd54e9b', component.options)
    } else {
      api.reload('4bd54e9b', component.options)
    }
    module.hot.accept("./YearlyReport.vue?vue&type=template&id=4bd54e9b&scoped=true&", function () {
      api.rerender('4bd54e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/Statistics/YearlyReport.vue"
export default component.exports